import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


function isWebviewOnChromebook(): boolean {
  const agent = navigator.userAgent;
  if (agent == null || agent === '') return false;
  if (agent.indexOf('Android 8') > -1) return true;
  if (agent.indexOf('Android 9') > -1) return true;
  if (agent.indexOf('Android 10') > -1) return true;
  if (agent.indexOf('Android 11') > -1) return true;
  return false;
}


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
